import Vue from 'vue'
import Vuex from 'vuex'
// 引入element默认的scss
import variables from '../style/element-variables.scss'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,
  state: {
    // element默认的scss中控制组件颜色的变量
    theme: variables.theme,
    // 全局的小区下拉的值
    allGardenId: 0,
    // 主题切换的值
    colorChange: {
      top: '#00b1c3',
      button: '#006d9a'
    },
    tabList: []
  },
  mutations: {
    // 主题换肤的set方法
    CHANGE_SETTING: (state, theme) => {
      state.theme = theme
    },
    setGardenId(state, allGardenId) {
      state.allGardenId = allGardenId
    },
    setColorChange(state, colorChange) {
      state.colorChange = colorChange
    },
    setTabList(state, tabList) {
      state.tabList = tabList
    }
  },
  getters: {
    getGardenId: state => state.allGardenId,
    getColorChange: state => state.colorChange,
    getTabList: state => state.tabList,
    getTheme: state => state.theme,
  },
  actions: {
  }
})
